export default __webpack_public_path__ + "static/10-a1c18cdefa2d34d722b8ad2fdfec7d5a.png";